import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { ITripsOverviewColumn } from '../interfaces';
import TooltipComponent from '../../TooltipComponent';
import { getIsColumnLast } from '../TableHeader/TableHeader';
import { columnsAtom } from '../TripsOverviewState';

interface IThConsumptionProps {
  id: string;
}

function ThConsumption(props: IThConsumptionProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const columnsTable = useRecoilValue<ITripsOverviewColumn[]>(columnsAtom);

  return (
    <div
      className={`th-sticky b-table-actions `}
      style={{
        minWidth: '200px',
        flex: 1,
        whiteSpace: 'nowrap',
        // cursor: 'pointer',
      }}
    >
      <TooltipComponent
        id={`ridebook-${props.id}`}
        overlay={
          <div style={{ color: '#fff', whiteSpace: 'pre-wrap', fontWeight: 'normal' }}>
            {`${f({
              id: 'tables.tripsOverview.column.fuelConsumption',
            })}: `}
            <strong>
              {`${f({
                id: 'tables.tripsOverview.header.tooltip.fuelConsumption',
              })}`}
            </strong>
          </div>
        }
        width="300px"
        style={{ top: '35px' }}
        positionLeft={getIsColumnLast(columnsTable, props.id)}
      >
        <div className="d-flex w-100">
          <div id={props.id} className="text-truncate">
            {f({ id: 'tables.tripsOverview.column.fuelConsumption' })}
          </div>
        </div>
      </TooltipComponent>
    </div>
  );
}

export default ThConsumption;
